import { easyMDEInit } from '../General/easyMDE'
import { savedPanel } from 'saved-panel-animations'
window.addEventListener('load', () => {
	initialise()
})
let easymde
const initialise = () => {
	const mdeEditor = document.querySelector('.mceEditor') as HTMLTextAreaElement
	easymde = easyMDEInit(mdeEditor)
	const btnInsertField = document.querySelector('.btnInsertField') as HTMLButtonElement
	if (btnInsertField != null) {
		btnInsertField.addEventListener('click', () => {
			InsertField(mdeEditor)
		})
	}
	const btnAddMailshotTemplate = document.querySelector('.btnAddMailshotTemplate') as HTMLButtonElement
	if (btnAddMailshotTemplate != null) {
		btnAddMailshotTemplate.addEventListener('click', () => {
			UpdateTemplate()
		})
	}
}
function InsertField (mdeEditor: HTMLTextAreaElement) {
	let ddl = ''
	const ddlMergeField = document.querySelector('.ddlMergeField') as HTMLSelectElement
	for (let i = 0; i < ddlMergeField.length; i++) {
		const field = ddlMergeField[i] as HTMLOptionElement
		if (field.selected) {
			ddl = field.text
		}
	}
	easymde.value(easymde.value() + ddl)
};
const UpdateTemplate = () => {
	const form = document.querySelector('.form') as HTMLFormElement
	const hidUpdateTemplate = document.getElementById('hidUpdateTemplate') as HTMLFormElement
	fetch(hidUpdateTemplate.value.toString(), {
		method: 'POST',
		body: new FormData(form)
	})
		.then(() => {
			savedPanel()
		})
		.catch((ex) => {
			alert('Failed calling /Home/AddClientIssue: ' + ex)
		})
}
